exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swiper-slide {\n  width: 80%;\n  max-width: 230px;\n  box-sizing: border-box;\n}\n.swiper-pagination-bullet {\n  width: 4px;\n  height: 4px;\n  vertical-align: middle;\n  background-color: white;\n  margin: 0 7.5px;\n}\n.swiper-pagination-bullet-active {\n  width: 9px;\n  height: 9px;\n}\n.swiper-pagination-bullets {\n  width: 100%;\n  margin-top: 20px;\n}\n.swiper-wrapper {\n  height: 300px;\n}\n@media (min-height: 669px) {\n.swiper-wrapper {\n    height: 365px;\n}\n}", ""]);

// exports
